import React from 'react';

function Question({ questionData, onAnswer }) {
  const { question, options, correct_answer } = questionData;

  const handleOptionClick = (selectedOption) => {
    const isCorrect = selectedOption === correct_answer;
    onAnswer(isCorrect);
  };

  return (
    <div className="question">
      <h2>{question}</h2>
      <div className="options">
        {options.map((option, index) => (
          <button
            key={index}
            onClick={() => handleOptionClick(option)}
            className="option-button"
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
}

export default Question;
